export default "__VITE_ASSET__BaYbYfC___"